export const OAuthErrorConstants = {
  Title: 'OAuth Failed',
  CTA: 'Go back to Paddle',
} as const
